import { render, staticRenderFns } from "./BrandedSignupSection.vue?vue&type=template&id=fde6c406"
import script from "./BrandedSignupSection.vue?vue&type=script&lang=ts"
export * from "./BrandedSignupSection.vue?vue&type=script&lang=ts"
import style0 from "./BrandedSignupSection.vue?vue&type=style&index=0&id=fde6c406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports